module.exports = __webpack_public_path__ + "img/P901.6e663f03.jpg";